/*!
 * Attaches Client Hints to Snowplow events v3.21.0 (http://bit.ly/sp-js)
 * Copyright 2022 Snowplow Analytics Ltd, 2010 Anthon Pang
 * Licensed under BSD-3-Clause
 */

var uaClientHints;
/**
 * This function makes sure that the expected array is returned as an array instead of an object.
 * It handles a problem that in some cases the `navigator.userAgentData.brands` was returned as an object instead of array.
 */
function forceArray(array) {
    if (Array.isArray(array))
        return array;
    if (Object.prototype.toString.call(array) === '[object Object]') {
        return Object.keys(array).map(function (e) {
            return array[e];
        });
    }
    return [];
}
/**
 * Returns the client-hints brands, ensuring no additional properties.
 */
function getBrands(brands) {
    return brands.map(function (b) {
        var brand = b.brand, version = b.version;
        return { brand: brand, version: version };
    });
}
/**
 * Validates whether userAgentData is compliant to the client-hints interface.
 * https://wicg.github.io/ua-client-hints/#interface
 */
function validClientHints(hints) {
    if (!hints || typeof hints.isMobile !== 'boolean' || !Array.isArray(hints.brands)) {
        return false;
    }
    if (hints.brands.length === 0 ||
        hints.brands.some(function (brand) { return typeof brand.brand !== 'string' || typeof brand.version !== 'string'; })) {
        return false;
    }
    return true;
}
/**
 * Attaches Client Hint information where available
 * @param includeHighEntropy - Should high entropy values be included
 */
function ClientHintsPlugin(includeHighEntropy) {
    var populateClientHints = function () {
        var navigatorAlias = navigator;
        var uaData = navigatorAlias.userAgentData;
        if (uaData) {
            var candidateHints_1;
            candidateHints_1 = {
                isMobile: uaData.mobile,
                brands: getBrands(forceArray(uaData.brands))
            };
            if (includeHighEntropy && uaData.getHighEntropyValues) {
                uaData
                    .getHighEntropyValues(['platform', 'platformVersion', 'architecture', 'model', 'uaFullVersion'])
                    .then(function (res) {
                    candidateHints_1.architecture = res.architecture;
                    candidateHints_1.model = res.model;
                    candidateHints_1.platform = res.platform;
                    candidateHints_1.uaFullVersion = res.uaFullVersion;
                    candidateHints_1.platformVersion = res.platformVersion;
                });
            }
            if (validClientHints(candidateHints_1)) {
                uaClientHints = candidateHints_1;
            }
        }
    };
    return {
        activateBrowserPlugin: function () {
            if (!uaClientHints) {
                populateClientHints();
            }
        },
        contexts: function () {
            if (uaClientHints) {
                return [
                    {
                        schema: 'iglu:org.ietf/http_client_hints/jsonschema/1-0-0',
                        data: uaClientHints
                    },
                ];
            }
            return [];
        }
    };
}

export { ClientHintsPlugin };
//# sourceMappingURL=index.module.js.map
